import { render, staticRenderFns } from "./user-dropdown.html?vue&type=template&id=54587a7c&scoped=true&"
import script from "./user-dropdown.js?vue&type=script&lang=js&"
export * from "./user-dropdown.js?vue&type=script&lang=js&"
import style0 from "./user-dropdown.scss?vue&type=style&index=0&id=54587a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54587a7c",
  null
  
)

export default component.exports